'use client'

import { useEffect } from 'react'
import { Page, Layout, Banner, Button, Text, BlockStack } from '@shopify/polaris'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error('App error:', error)
  }, [error])

  return (
    <Page title="Something went wrong">
      <Layout>
        <Layout.Section>
          <Banner tone="critical" title="Application error">
            <BlockStack gap="200">
              <Text as="p" variant="bodyMd">{error.message || 'A client-side exception occurred.'}</Text>
              <Text as="p" variant="bodySm" tone="subdued">
                If you see &quot;Missing access token&quot;, try reinstalling the app from your Shopify admin.
              </Text>
              <Button onClick={reset} variant="primary">
                Try again
              </Button>
            </BlockStack>
          </Banner>
        </Layout.Section>
      </Layout>
    </Page>
  )
}
